import api from "@/services/api/exercise/api-payments";
import {OrderModel} from "@/app/exercise/modules/payments/core/models/OrderModel";
import {PlanModel} from "@/app/exercise/modules/payments/core/models/PlanModel";

export class PaymentsService {
  constructor() {
  }

  async loadPlans(query) {
    try {
      const res = await api.loadPlans(query);
      if(!res) throw new Error('Something went wrong and list is not loading. Please, reload page or try again later.');
      return {
        results: res.map( item => new PlanModel(item) ),
      };
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async loadOrders(query) {
    try {
      const res = await api.loadOrders(query);
      if(!res) throw new Error('Something went wrong and list is not loading. Please, reload page or try again later.');
      return {
        results: res.results.map( item => new OrderModel(item) ),
        pagination: {
          count: res.count,
        }
      };
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async createPlan(model) {
    try {
      return await api.createPlan(model.getApiData());
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async putPlan(id, model) {
    try {
      return await api.putPlan(id, model.getApiData());
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async removePlan(id) {
    try {
      return await api.removePlan(id);
    } catch (error) {
      return Promise.reject(error);
    }
  }

}
